var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container" }, [
      _c("p", { staticClass: "mt-3", staticStyle: { color: "#7F7F7F" } }, [
        _c("strong", [_vm._v("วันนี้ - 22 สิงหาคม 2567")])
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("strong", [_vm._v("1 Million Bookings Celebration ")]),
        _vm._v("ยิ่งจอง ยิ่งได้ลุ้น (จับรางวัลทุกสัปดาห์)")
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "responsive mb-5",
        attrs: {
          src:
            "https://beneat.s3.ap-southeast-1.amazonaws.com/promotions/million-booking-celebrate-info.png",
          alt: "1 Million Bookings Celebration ยิ่งจอง ยิ่งได้ลุ้น"
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-464742ff", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464742ff","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPage/MillionBookingCelebrateInfo.vue
// module id = 2474
// module chunks = 0